<template>
  <component
    :is="uiStore.isMobile ? GenericSideMenu : 'div'"
    class="MediaBankFilters"
    :title="$t('filter.modalTitle')"
    content-class="!p-0"
    :self-contained="true"
    :no-background="true"
    position="left"
    @close="$emit('closeFilter')"
  >
    <div>
      <div
        v-for="group in filterGroups"
        :key="group.key"
      >
        <MediaBankFilterGroup
          :filter-key="group.key"
          :label="$t(group.labelKey)"
          :options="group.options"
          @set-filter="(code, selected) => onSetFilter(group.key, code, selected)"
          @reset="onReset(group.key)"
          @close="$emit('closeFilter')"
        />
      </div>
    </div>

    <template #bottom>
      <div class="flex w-full p-16 overflow-hidden bg-lightest border-t border-light">
        <div class="basis-1/4">
          <button
            class="w-full btn btn--secondary !px-12"
            @click="$emit('reset')"
          >
            {{ $t('filter.button.clear') }}
          </button>
        </div>
        <div class="basis-8 shrink-0" />
        <div class="basis-3/4">
          <button
            class="w-full btn !px-8"
            @click="$emit('closeFilter')"
          >
            {{ $t('mediaBank.filter.show', { num: totalResults }) }}
          </button>
        </div>
      </div>
    </template>
  </component>
</template>

<script setup lang="ts">
import { useUiStore } from '~/store/ui';
import GenericSideMenu from '~/components/menu/GenericSideMenu.vue';
import MediaBankFilterGroup from '~/components/media-bank/MediaBankFilterGroup.vue';
import type { MediaBankFilterGroupItem, MediaBankActiveFilters } from '#constants/types/mediaBank';

const { $t } = useNuxtApp();
const uiStore = useUiStore();

const props = defineProps<{
  filterGroups: MediaBankFilterGroupItem[];
  totalResults: number;
  activeFilters: MediaBankActiveFilters;
}>();

const emit = defineEmits<{
  (e: 'setFilter', key: keyof MediaBankActiveFilters, values: string[]): void;
  (e: 'reset'): void;
  (e: 'closeFilter'): void;
}>();

const onSetFilter = (
  key: keyof MediaBankActiveFilters,
  code: string,
  selected: boolean
) => {
  const current = [...(props.activeFilters[key] ?? [])];
  if (selected) {
    if (!current.includes(code)) current.push(code);
  } else {
    const idx = current.indexOf(code);
    if (idx > -1) current.splice(idx, 1);
  }
  emit('setFilter', key, current);
};

const onReset = (key: keyof MediaBankActiveFilters) => {
  emit('setFilter', key, []);
};
</script>
